export default __webpack_public_path__ + "static/media/fallout-item-6.1328a427.png";